export default __webpack_public_path__ + "static/media/Akanksha Parijat_Design Team Lead.c8b49852.jpg";